import React from "react";

const IncredGroup = () => {
    return (
        <div className="flex flex-col items-center justify-center md:pt-20 md:pb-36 md:px-36">
            <div className="flex w-full max-w-4xl flex-col md:items-start justify-between md:flex-row items-center">
                <div className="md:w-[38%]">
                    <h2 id="vision-heading" className="text-4xl font-semibold text-neutral-900 md:text-left text-center md:mt-0 mt-8">InCred Group</h2>
                    <div className="hidden md:block mt-10 h-[1px] w-80 bg-orange-500"></div>
                </div>
                <div className="mt-4 md:mt-0 md:w-[61%]">
                    <p id="vision-para" className="text-neutral-500 md:text-base text-sm font-normal md:text-justify text-center">
                        InCred is a new-age diversified financial services group that has established
                        a strong reputation across multiple businesses in the rapidly evolving Indian 
                        financial services market.
                    </p>
                    <div className="md:block hidden mt-4 h-[1px] w-100 bg-gray-300"></div>
                </div>
            </div>

            <div className="md:mt-10 mt-5 flex w-full max-w-4xl items-center rounded-2xl border border-gray-200 px-6 md:flex-row flex-col-reverse md:mb-0 mb-[54px]">
                <div className="md:mb-0 md:w-1/3">
                    <img 
                        src={`${process.env.ICM_PUBLIC_ASSETS_URL}images/webp/Bhupinder.webp`} 
                        alt="Bhupinder Singh" 
                        className="md:w-[80%] rounded-lg"
                        id="owner-img"
                    />
                </div>
                <div className="w-full md:w-2/3 md:pl-32 md:text-justify text-center">
                    <h3 id="vision-sub-heading" className="text-4xl font-semibold text-neutral-900 mt-6">Our Vision</h3>
                    <p id="vision-sub-para" className="mt-2 text-base text-neutral-900">
                        To build a world-class financial services brand that meets the economic 
                        needs of every Indian family and plays a meaningful role in shaping the 
                        country’s financial ecosystem.
                    </p>
                    <p id="vision-incred-ceo" className="mt-4 text-base font-semibold text-neutral-900 md:mb-0 mb-[54px]">
                        Bhupinder Singh<br />
                        <span>Founder &amp; Group CEO, InCred</span>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default IncredGroup;
